import { LoadablePeople } from '.';

export default {
  path: 'accounts/:id/people/:contentView?/:peopleId?',
  name: 'People',
  component: LoadablePeople,
};
